/* ============================================================
   Puntitos de carga en el botón "Tramitar pedido" (carrito lateral).

   El botón es un envío de formulario (type="submit") que navega al checkout
   al instante, por eso los puntitos no llegaban a verse.

   SOLUCIÓN: en el PRIMER clic bloqueamos TODO (preventDefault +
   stopImmediatePropagation, por si el tema tiene su propio manejador),
   mostramos los puntitos un momento, y LUEGO re-disparamos el clic real
   (marca data-nr-co-go) para que el envío nativo al checkout siga su curso
   con los productos del carrito.

   Carga global (el carrito lateral aparece en todas las páginas).
   ============================================================ */
(function () {
  'use strict';
  if (window.__nrCoInit) return;
  window.__nrCoInit = true;

  var SEL = '#checkout, [name="checkout"], .cart__checkout-button, .icd-checkout, [data-icd-checkout]';
  var DELAY = 650; // ms visibles de puntitos antes de ir al checkout

  function injectDots(btn) {
    if (!btn.querySelector('.nr-co-dots')) {
      var d = document.createElement('span');
      d.className = 'nr-co-dots';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<span></span><span></span><span></span>';
      btn.appendChild(d);
    }
  }

  function clear(btn) {
    btn.classList.remove('nr-co-loading');
    try { delete btn.dataset.nrCoGo; } catch (err) {}
    var x = btn.querySelector('.nr-co-dots');
    if (x && x.parentNode) x.parentNode.removeChild(x);
  }

  function begin(btn) {
    btn.classList.add('nr-co-loading');
    injectDots(btn);

    setTimeout(function () {
      btn.dataset.nrCoGo = '1';
      btn.click(); // re-disparo real -> envío nativo al checkout (incluye name="checkout")
    }, DELAY);

    window.addEventListener('pageshow', function () { clear(btn); }, { once: true });
    setTimeout(function () { clear(btn); }, 9000);
  }

  function handle(e, btn) {
    // Segundo disparo (el nuestro): dejar pasar TODO con normalidad.
    if (btn.dataset && btn.dataset.nrCoGo === '1') return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    // Bloqueamos el envío nativo y cualquier manejador del tema en este primer clic.
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    else e.stopPropagation();

    if (!btn.classList.contains('nr-co-loading')) begin(btn);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(SEL);
    if (btn) handle(e, btn);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = document.activeElement;
    if (!el || !el.closest) return;
    var btn = el.closest(SEL);
    if (!btn) return;
    if (btn.dataset && btn.dataset.nrCoGo === '1') return;
    if (btn.disabled) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (!btn.classList.contains('nr-co-loading')) begin(btn);
  }, true);
})();
